module.exports = __webpack_public_path__ + "static/media/mmusician-lg-6.7c88448c.jpg";